import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import CloseIcon from '@mui/icons-material/Close'
import { Backdrop } from '@mui/material'
import React from 'react'
import * as styles from './Lightbox.module.scss'
import { PhotoInterface } from '../../../interfaces/PhotoInterface'
import Photo from '../../Photo'
import Video from '../../Video/Video'

type Props = {
  items: PhotoInterface[]
  open?: boolean
  index?: number
  onClose: () => void
  loop?: boolean
  showCounter?: boolean
}

export const Lightbox = (props: Props) => {
  const [index, setIndex] = React.useState<number>(props.index || 0)
  const { items } = props

  React.useEffect(() => {
    setIndex(props.index || 0)
  }, [props.index])

  React.useEffect(() => {
    if (props.open) {
      document.body.style.overflow = 'hidden'
    }
    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [props.open])

  const onPrev = () => {
    if (index > 0) {
      setIndex(index - 1)
    } else if (props.loop) {
      setIndex(items.length - 1)
    }
  }

  const onNext = () => {
    if (index < items.length - 1) {
      setIndex(index + 1)
    } else if (props.loop) {
      setIndex(0)
    }
  }

  if (!props.open || index == -1) {
    return null
  }

  return (
    <Backdrop open={props.open} classes={{ root: styles['lightbox'] }}>
      <div className={styles['content']}>
        <div className={styles['nav']}>
          <CloseIcon fontSize="large" classes={{ root: styles['nav__close'] }} onClick={props.onClose} />
        </div>
        {props.items[index].mediaType === 2 ? (
          <Video
            sources={[{ src: props.items[index].url, type: 'video/mp4', withCredentials: true }]}
            options={{
              controls: true,
              fill: false,
              fluid: false,
              responsive: true,
              //@ts-ignore
              cover: window.location.search.includes('cover') || false,
              aspectRatio: '1:1',
            }}
            className={styles['video']}
          />
        ) : (
          <Photo src={props.items[index].url} classes={styles['image']} noEmpty />
        )}
        <div className={styles['nav-bottom']}>
          {props.showCounter ? (
            <span className={styles['counter']}>
              {index + 1}/{items.length}
            </span>
          ) : null}
        </div>
        <div className={styles['arrow--left']}>
          {props.loop || index > 0 ? <ArrowBackIosIcon classes={{ root: styles['arrow__icon'] }} onClick={onPrev} /> : null}
        </div>
        <div className={styles['arrow--right']}>
          {props.loop || index < items.length - 1 ? (
            <ArrowForwardIosIcon classes={{ root: styles['arrow__icon'] }} onClick={onNext} />
          ) : null}
        </div>
      </div>
    </Backdrop>
  )
}

export default Lightbox
